const accessErrorFactory = (err) => {
  if (err && err.code === "ERR_CANCELED") {
    return null;
  }

  if (err && err.response && err.response.status === 410) {
    return {
      message: "The access link has expired.",
      blocking: true,
    };
  }

  if (err && err.response && err.response.status === 423) {
    return {
      message: "The document is no longer available.",
      blocking: true,
    };
  }

  return {
    message: "An Unexpected Error Occurred",
    blocking: false,
  };
};

export default accessErrorFactory;
